import { render } from "./Col5.vue?vue&type=template&id=38807500"
import script from "./Col5.vue?vue&type=script&lang=js"
export * from "./Col5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__